import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { Exporter } from 'dashboard/models/exporter';
import { User } from 'dashboard/models/user';
import { ExportersActions, ExportersActionType } from 'dashboard/redux/actions/exporters';

export type Exporters = Exporter[];

export interface ExportersState extends Omit<Omit<TableState<{}>, 'sortParams'>, 'filters'> {
  exporters: Exporters;
  users: User[];
}

const initialState: ExportersState = {
  exporters: [],
  users: [],
  paginationParams: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export default (state: ExportersState = initialState, action: ExportersActions) => {
  switch (action.type) {
    case ExportersActionType.SaveExporters: {
      return {
        ...state,
        exporters: action.payload.exporters,
        paginationParams: action.payload.paginationParams,
      };
    }

    case ExportersActionType.SavePageSize: {
      return {
        ...state,
        pageSize: action.payload.pageSize,
      };
    }

    case ExportersActionType.SaveCurrentPage: {
      return {
        ...state,
        currentPage: action.payload.currentPage,
      };
    }

    case ExportersActionType.SetExporterDetails: {
      return {
        ...state,
        users: action.payload.users,
      };
    }

    default:
      return state;
  }
};
